import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../../modal/PropdocsModal';
import styles from './styles.module.scss';
import { OptionalMessageInputRef } from '../../document-wizard-modal/custom-modals/document-wizard-action-modal/OptionalMessageInputRef';

interface CancelSigningPreparationModalProps {
  onHide: () => void;
  isLoading: boolean;
  onConfirm: () => void;
  show: boolean;
  additionalMessageInputRef: React.Ref<HTMLTextAreaElement>;
}

const CancelSigningPreparationModal = ({
  onHide,
  isLoading,
  onConfirm,
  show,
  additionalMessageInputRef,
}: CancelSigningPreparationModalProps) => {
  return (
    <PropdocsModal
      show={show}
      setShow={onHide}
      size="lg"
      title={<FormattedMessage id="document-wizard-modal.send-for-signing" defaultMessage="Edit Document" />}
      disableClose={isLoading}
    >
      <>
        <div className={styles.main} style={{ marginBottom: '1.5rem' }}>
          To edit this document, you must cancel the signing preparation. When this document is returned to signing
          preparation, some of the inserted tags may be moved as a result of changes to the document.
        </div>
        <OptionalMessageInputRef ref={additionalMessageInputRef} />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>
          <Button variant="link" className="text-secondary" onClick={onHide} disabled={isLoading}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={onConfirm} disabled={isLoading} className={styles['cancel-button']}>
            {isLoading ? (
              <FormattedMessage id="common.loading" defaultMessage="Loading..." />
            ) : (
              <FormattedMessage id="common.edit-document" defaultMessage="Edit Document" />
            )}
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default CancelSigningPreparationModal;
